function ChangePasswordCtrl($scope, $stateParams, $http, $sce, authService, sdkAuthService, sdkUtils, $state, $timeout) {
  _initScope();

  function _initScope() {
    $scope.changePasswordForm = {};
    $scope.token = $stateParams.token;
    $scope.username = $stateParams.username;

    $scope.passwordSaved = false;
    $scope.saving = false;
    $scope.error = null;

    authService.logout();

    /**
     * @desc Change password for user
     * @param {Object} form - Angular form object
     * @param {Object} [$event] - Angular event object
     */
    $scope.changePassword = _changePassword;
  }

  function _changePassword(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;

    if (!form.$valid) return;

    $scope.saving = true;

    sdkAuthService.changePassword({
        password: $scope.changePasswordForm.password,
        resetToken: $scope.token
      })
      .then(() => {
        $state.go('login', {
          changedPasswordMsg: 'Your password has been updated. Please login.'
        });
      })
      .catch(response => {
        $scope.error = sdkUtils.getErrorFromResponse(response);

        $timeout(() => {
          $scope.error = null;
        }, 6000);
      })
      .finally(() => {
        $scope.saving = false;
      });
  }
}

ChangePasswordCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$http',
  '$sce',
  'authService',
  'jsSdk.auth',
  'jsSdk.utils',
  '$state',
  '$timeout'
];

export default ChangePasswordCtrl;



// WEBPACK FOOTER //
// ./src/components/changePassword/changePasswordCtrl.js